/** Tipos de contato */
export interface ContatoTipo {
    id: number;
    nome: string;
    descricao: string;
    iconClass: string;
}

export const CONTATO_TIPO_QUALIFICACAO: ContatoTipo = {
    id: 1,
    nome: 'Qualificação',
    descricao: 'Contato para qualificar um lead',
    iconClass: 'fas fa-bullseye'
};

export const CONTATO_TIPO_PROSPECCAO: ContatoTipo = {
    id: 2,
    nome: 'Prospecção',
    descricao: 'Contato para prospectar um novo cliente',
    iconClass: 'fab fa-searchengin'
};

export const CONTATO_TIPO_NEGOCIACAO: ContatoTipo = {
    id: 3,
    nome: 'Negociação',
    descricao: 'Contato para discutir assuntos sobre negociações',
    iconClass: 'fas fa-handshake'
};

export const CONTATO_TIPO_ACOMPANHAMENTO_PEDIDO: ContatoTipo = {
    id: 4,
    nome: 'Acompanhamento de Pedido',
    descricao: 'Contato para saber mais informações sobre um determinado pedido',
    iconClass: 'far fa-eye'
};

export const CONTATO_TIPO_SUPORTE: ContatoTipo = {
    id: 5,
    nome: 'Suporte',
    descricao: 'Contato para fornecimento de suporte',
    iconClass: 'far fa-life-ring'
};

export const CONTATO_TIPO_POS_VENDA: ContatoTipo = {
    id: 6,
    nome: 'Pós-Venda',
    descricao: 'Contato de pós-venda',
    iconClass: 'far fa-grin-hearts'
};

export const CONTATO_TIPO_FEEDBACK: ContatoTipo = {
    id: 7,
    nome: 'Feedback',
    descricao: 'Contato para dar feedback',
    iconClass: 'far fa-comment-dots'
}

export const CONTATO_TIPO_RECLAMACAO: ContatoTipo = {
    id: 8,
    nome: 'Reclamação',
    descricao: 'Contato para realizar alguma reclamação',
    iconClass: 'far fa-angry'
};

export const CONTATO_TIPO_OUTRO: ContatoTipo = {
    id: 99,
    nome: 'Outro',
    descricao: 'Outro tipo de contato',
    iconClass: 'far fa-question-circle'
};



export const CONTATOS_TIPOS: ContatoTipo[] = [
    CONTATO_TIPO_QUALIFICACAO,
    CONTATO_TIPO_PROSPECCAO,
    CONTATO_TIPO_NEGOCIACAO,
    CONTATO_TIPO_ACOMPANHAMENTO_PEDIDO,
    CONTATO_TIPO_SUPORTE,
    CONTATO_TIPO_POS_VENDA,
    CONTATO_TIPO_FEEDBACK,
    CONTATO_TIPO_RECLAMACAO,
    CONTATO_TIPO_OUTRO
];

/** Verifica se o tipo de contato é qualificação */
export function isContatoTipoQualificacao(id: number): boolean {
    return id === CONTATO_TIPO_QUALIFICACAO.id;
}

/** Verifica se o tipo de contato é prospecção */
export function isContatoTipoProspeccao(id: number): boolean {
    return id === CONTATO_TIPO_PROSPECCAO.id;
}


/** Verifica se o tipo de contato é negociação */
export function isContatoTipoNegociacao(id: number): boolean {
    return id === CONTATO_TIPO_NEGOCIACAO.id;
}


/** Verifica se o tipo de contato é acompanhamento de pedido */
export function isContatoTipoAcompanhamentoPedido(id: number): boolean {
    return id === CONTATO_TIPO_ACOMPANHAMENTO_PEDIDO.id;
}

/** Verifica se o tipo de contato é suporte */
export function isContatoTipoSuporte(id: number): boolean {
    return id === CONTATO_TIPO_SUPORTE.id;
}


/** Verifica se o tipo de contato é pós-venda */
export function isContatoTipoPosVenda(id: number): boolean {
    return id === CONTATO_TIPO_POS_VENDA.id;
}


/** Verifica se o tipo de contato é feedbacl */
export function isContatoTipoFeedback(id: number): boolean {
    return id === CONTATO_TIPO_FEEDBACK.id;
}

/** Verifica se o tipo de contato é reclação */
export function isContatoTipoReclamacao(id: number): boolean {
    return id === CONTATO_TIPO_RECLAMACAO.id;
}


/** Verifica se o tipo de contato é outro */
export function isContatoTipoOutro(id: number): boolean {
    return id === CONTATO_TIPO_OUTRO.id;
}

